/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationEntry } from './communicationEntry';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedCommunicationEntryList { 
    next?: string | null;
    previous?: string | null;
    results: Array<CommunicationEntry>;
}
export const PaginatedCommunicationEntryList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedCommunicationEntryList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedCommunicationEntryList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


